import React, { useState, useEffect, useRef } from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';

const AntdDateCellEditor = (props) => {
  const [value, setValue] = useState(props.value ? moment(props.value) : null);
  const refInput = useRef(null);

  useEffect(() => {
    // Focus on the input when the editor is created
    refInput.current?.focus();
  }, []);

  const getValue = () => {
    return value ? value.format('YYYY-MM-DD') : null;
  };

  const handleChange = (date) => {
    setValue(date);
    props.api.stopEditing();
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      props.api.stopEditing();
    }
    if (event.key === 'Escape') {
      props.api.stopEditing();
    }
  };

  return (
    <DatePicker
      ref={refInput}
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      style={{ width: '100%' }}
      autoFocus
      format="YYYY-MM-DD"
      placeholder="Select date..."
    />
  );
};

export default AntdDateCellEditor;
